module.exports = __webpack_public_path__ + "img/racecourse-barrowdalePark-turf-2200.b91f74e1.svg";